import React from 'react'
import { Button, Modal } from 'react-bootstrap'
import CancellationPolicy from '../content/cancellationPolicy'
import RoomReassignment from '../content/roomReassignment'
import ItemDamageClause from '../content/itemDamageClause'
import { connect } from 'react-redux'
import { programSelector } from '../../redux/modules/searchParamsModule'

const TermsConditionsDialog = connect(state => ({
  program: programSelector(state)
}))(({ showDialog, closeFn, program }) => {
  return (
    <Modal show={showDialog} onHide={closeFn} className='warning-alert'>
      <Modal.Header closeButton>
        <Modal.Title>Terms and Conditions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className='terms-conditions'>
          <li>
            <strong>Adiyogi Darshan Check-in/Check-Out Times:</strong> Check-in
            Time is 3pm CST, Check-out time is 12pm CST. Please note that your
            accommodation will be available starting at 3pm on the day of
            check-in.
          </li>
          <li>
            <strong>Entry and Exit:</strong> The campus gate is locked from 8pm
            CST - 8:30am CST. Please arrange your travel to arrive outside of
            these hours so that you can enter. In case of any emergencies where
            you cannot arrive within the open-gate hours, please inform the
            Welcome Center by calling (931) 668-1900. To exit, when the gate is
            locked, the gate will automatically open when you drive up to it.
          </li>
          <li>
            <strong>Pets:</strong> Pets, including therapy dogs, are not
            allowed.
          </li>
          <li>
            <strong>Special Needs:</strong> In case of any special needs or
            requests, please inform Isha Institute directly at (931) 668-1900 or
            visit the website support.ishafoundation.org
          </li>
          <li>
            <strong>Children:</strong> Children 14 and below must be accompanied
            by a parent or guardian at all times.
          </li>
          <li>
            <strong>Communication:</strong> Many cellphone carriers do not have
            service at Isha Institute. For urgent situations, there are landline
            phones available for use in the Welcome Center, Laurel Studios A, B,
            and C first floor laundry rooms and outside Cabin H1.
          </li>
          <li>
            <strong>Wifi:</strong> To support one's Sadhana (tool for spiritual
            growth) the WiFi networks will be turned off from 10:30 PM to 3:30
            AM daily. To facilitate essential communication during this time, a
            separate WiFi network named "Whatsapp" will be available daily. This
            network will be exclusively for WhatsApp communication.
          </li>
          <li>
            <strong>Changes to registrations:</strong> To make any changes to
            your registration before arriving, please inform Isha Institute
            directly at (931) 668-1900 or visit the website
            support.ishafoundation.org. To make any changes to the accommodation
            during your visit, please contact the Welcome Center.
          </li>
          <li>
            <CancellationPolicy program={program} />
          </li>

          <li>
            <ItemDamageClause />
          </li>
          <li>
            <RoomReassignment />
          </li>
          <li>
            The following items are prohibited at the Isha Institute at all
            times to maintain an environment conducive to everyone's spiritual
            growth and wellbeing: alcohol, cigarettes/tobacco, illicit drugs,
            and meat products.
          </li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={closeFn}>Close</Button>
      </Modal.Footer>
    </Modal>
  )
})

export default TermsConditionsDialog



// WEBPACK FOOTER //
// ./src/components/searchBar/termsConditionsDialog.js